/**
 * 兑换码
 * 兑换码API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CreatedVo from '../../redeem_code/model/CreatedVo';
import PagingRedeemCodeBatchVo from '../../redeem_code/model/PagingRedeemCodeBatchVo';
import RedeemCodeGenVo from '../../redeem_code/model/RedeemCodeGenVo';
  /**
   * RedeemCode service.
   * @module redeem_code/api/RedeemCodeApi
   * @version 0.2.0
   */

  /**
   * Constructs a new RedeemCodeApi. 
   * @alias module:redeem_code/api/RedeemCodeApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 根据id下载excel
     * @param {Integer} id 批次id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link File}
     */
this.downloadRedeemCode = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling downloadRedeemCode";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
      var returnType = File;
      return this.apiClient.callApi(
        '/api/redeem_code/batch/{id}/excel', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 分页查询兑换码批次
     * @param {Integer} pageNum 页码
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.textbookId 教材id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:redeem_code/model/PagingRedeemCodeBatchVo}
     */
this.findPagingRedeemCodeBatch = function(pageNum, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling findPagingRedeemCodeBatch";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageNum': pageNum,
        'textbookId': opts['textbookId']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingRedeemCodeBatchVo;
      return this.apiClient.callApi(
        '/api/redeem_code/batch', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 生成兑换码
     * @param {module:redeem_code/model/RedeemCodeGenVo} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:redeem_code/model/CreatedVo}
     */
this.genRedeemCode = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling genRedeemCode";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/redeem_code/batch', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
